import React from "react";

const TickCircleIcon = ({
    width = "17",
    height = "17",
    viewBox = "0 0 17 17",
    stroke = "#008A15",
    ...props
}) => (
    <svg
        width={width}
        height={height}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.50008 15.5832C12.3959 15.5832 15.5834 12.3957 15.5834 8.49984C15.5834 4.604 12.3959 1.4165 8.50008 1.4165C4.60425 1.4165 1.41675 4.604 1.41675 8.49984C1.41675 12.3957 4.60425 15.5832 8.50008 15.5832Z"
            stroke={stroke}
            strokeWidth="1.59375"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.48999 8.50016L7.49457 10.5047L11.5108 6.49561"
            stroke={stroke}
            strokeWidth="1.59375"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default TickCircleIcon;
